module.exports = __webpack_public_path__ + "img/hpp1.97e5226b.jpg";